export default "images/about.png";